export default [
  {
    path: "/user",
    name: "用户列表",
    component: () => import("../views/systemSetting/user/index.vue"),
  },
  {
    path: "/menu",
    name: "菜单管理",
    component: () => import("../views/systemSetting/menu/Menu.vue"),
  },
  {
    path: "/role",
    name: "角色管理",
    component: () => import("../views/systemSetting/role/Role.vue"),
  },
  {
    path: "/msgTemple",
    name: "消息模板",
    component: () => import("../views/systemSetting/message/index.vue"),
  },
  {
    path: "/dictionaries",
    name: "字典管理",
    component: () =>
      import("../views/systemSetting/dictionaries/dictionaries.vue"),
  },
];
